import { isNotAuthenticated, logoutUser } from '@/utils/nav-guards-checks';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/app/auth/pages/page-home'),
    beforeEnter: isNotAuthenticated,
    redirect: { name: 'login' },
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('@/app/auth/components/the-login'),
      },
      {
        path: 'sign-up',
        name: 'sign-up',
        component: () => import('@/app/auth/components/the-sign-up'),
      },
      {
        path: 'auth/confirm-email',
        name: 'confirm-email',
        props: route => ({
          token: route.query.token,
          email: route.query.email,
        }),
        component: () => import('@/app/auth/components/the-confirm-email'),
      },
      {
        path: 'forgot-password',
        name: 'forgot-password',
        component: () => import('@/app/auth/components/the-forgot-password'),
      },
      {
        path: 'auth/reset-password',
        name: 'reset-password',
        props: route => ({
          token: route.query.token,
          email: route.query.email,
        }),
        component: () => import('@/app/auth/components/the-create-password'),
      },
      {
        path: 'admin/set-password',
        name: 'set-password',
        props: route => ({
          token: route.query.token,
          email: route.query.email,
        }),
        component: () => import('@/app/auth/components/the-set-password'),
      },
      {
        path: 'logout',
        name: 'logout',
        beforeEnter: logoutUser,
      },
      {
        path: 'error',
        name: 'error',
        component: () => import('@/app/auth/components/the-error-page'),
      },
    ],
  },
];

export default routes;
